import { Action } from '@ngrx/store';
import {
  BookingReportCalendarFilter,
  BookingReportTableFilter,
  BookingReportViewType,
  CalendarViewType,
} from '../booking-report-filters/booking-report-filters.models';
import { BookingReportCalendarItem } from '../booking-report-calendar/booking-report-calendar.models';
import { BookingReportTableItem } from '../booking-report-table/booking-report-table.models';
import { PagedList } from '@deltager/organizers/admin/shared/models/paged-list.model';

export enum BookingReportActionTypes {
  UpdateViewTypes = '[Booking report] Update view types',
  UpdateCalendarFilters = '[Booking report] Update calendar filters',
  UpdateTableFilters = '[Booking report] Update table filters',
  LoadCalendarItemsRequest = '[Booking report] Load calendar items request',
  LoadCalendarItemsSuccess = '[Booking report] Load calendar items success',
  LoadTableItemsRequest = '[Booking report] Load table items request',
  LoadTableItemsSuccess = '[Booking report] Load table items success',
  ClearBookingReportFilters = '[Booking report] Clear filters',
  ResetBookingReportStore = '[Booking report] Reset store',
}

// Update view types
export class BookingReportUpdateViewTypesAction implements Action {
  readonly type = BookingReportActionTypes.UpdateViewTypes;

  constructor(public payload: { view: BookingReportViewType; calendarType?: CalendarViewType }) {}
}

// Update calendar filters
export class BookingReportUpdateCalendarFiltersAction implements Action {
  readonly type = BookingReportActionTypes.UpdateCalendarFilters;

  constructor(public payload: BookingReportCalendarFilter) {}
}

// Update table filters
export class BookingReportUpdateTableFiltersAction implements Action {
  readonly type = BookingReportActionTypes.UpdateTableFilters;

  constructor(public payload: BookingReportTableFilter) {}
}

// Load calendar items
export class BookingReportLoadCalendarItemsRequestAction implements Action {
  readonly type = BookingReportActionTypes.LoadCalendarItemsRequest;

  constructor() {}
}

export class BookingReportLoadCalendarItemsSuccessAction implements Action {
  readonly type = BookingReportActionTypes.LoadCalendarItemsSuccess;

  constructor(public payload: BookingReportCalendarItem[]) {}
}

// Load table items
export class BookingReportLoadTableItemsRequestAction implements Action {
  readonly type = BookingReportActionTypes.LoadTableItemsRequest;

  constructor(public payload: { pageNumber: number } = null) {}
}

export class BookingReportLoadTableItemsSuccessAction implements Action {
  readonly type = BookingReportActionTypes.LoadTableItemsSuccess;

  constructor(public payload: { items: PagedList<BookingReportTableItem>; pageNumber?: number }) {}
}

// Clear filters
export class ClearBookingReportFiltersAction implements Action {
  readonly type = BookingReportActionTypes.ClearBookingReportFilters;
}

// Reset store
export class ResetBookingReportStoreAction implements Action {
  readonly type = BookingReportActionTypes.ResetBookingReportStore;
}
